import type { ChoiceEffect } from '@/content/dialogue/types';
import { useMarkets } from '@/state/markets';
import { useLife, type RelationshipId } from '@/state/life';
import { usePower } from '@/state/power';
import { useNotifications } from '@/state/notifications';
import { useXClone } from '@/state/xclone';
import type { TribeId } from '@/content/xcloneHandles';

export function applyChoiceEffects(effects: ChoiceEffect[] | undefined): void {
  if (!effects || effects.length === 0) return;
  for (const e of effects) {
    switch (e.type) {
      case 'cash':
        useMarkets.getState().addCash(Number(e.value ?? 0));
        break;
      case 'rep':
        if (e.target) useLife.getState().bumpRelationship(e.target as RelationshipId, Number(e.value ?? 0));
        break;
      case 'sanity':
        useLife.getState().bumpSanity(Number(e.value ?? 0));
        break;
      case 'irsHeat':
        useLife.getState().bumpIrsHeat(Number(e.value ?? 0));
        break;
      case 'secHeat':
        useLife.getState().bumpSecHeat(Number(e.value ?? 0));
        break;
      case 'fbiHeat':
        useLife.getState().bumpFbiHeat(Number(e.value ?? 0));
        break;
      case 'notoriety':
        usePower.getState().bumpNotoriety(Number(e.value ?? 0));
        break;
      case 'tribeRep':
        if (e.target) usePower.getState().bumpRep(e.target as TribeId, Number(e.value ?? 0));
        break;
      case 'tweet':
        if (typeof e.value === 'string') useXClone.getState().composePost(e.value);
        break;
      case 'note':
        useNotifications.getState().push({
          surfaceId: 'phone',
          severity: 'info',
          text: String(e.value ?? ''),
        });
        break;
      case 'arc':
        // Lazy-load the arc module by id and call its start() export. Arcs
        // export different start fn names (`startYachtTrip`, `startPodcastAppearance`, etc),
        // so we try common variants — first matching wins.
        if (typeof e.value === 'string') {
          const arcId = e.value;
          import(`./${arcId}.ts`)
            .then((m) => {
              const fn = m.start ?? m.default ?? Object.values(m).find((v: unknown) => typeof v === 'function');
              if (typeof fn === 'function') (fn as () => void)();
            })
            .catch(() => { /* unknown arc — silent skip */ });
        }
        break;
    }
  }
}
